import 'react-table/react-table.css';
import React from 'react';
import { I18n } from 'react-redux-i18n';
import _ from 'lodash';
import Table from '../../../components/table/Table';
import addNotification from '../../../components/notification';

export default class CrossdockingOrderTable extends React.Component {
  constructor(props) {
    super(props);

    const tableColumns = [
      {
        Header: I18n.t('BEE22' /* Cliente */),
        accessor: 'customer',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? `${row.value.code} - ${row.value.name}` : ''}
          </span>
        ),
      },
      {
        Header: I18n.t('BEE443' /* Documento */),
        accessor: 'customerOrderCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      },
      {
        Header: I18n.t('BEE4347' /* Cross-Docking */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      },
    ];

    this.defaultSorted = [
      {
        id: 'customerOrderCode',
        desc: false,
      },
    ];

    this.state = {
      tableColumns,
      customerOrders: this.filterCustomerOrders(this.props.customerOrders),
    };
  }

  selectCustomerOrder = async (data) => {
    const { quantityChecked } = this.props;
    if (parseFloat(quantityChecked) > parseFloat(data.quantity)) {
      addNotification(
        'danger',
        I18n.t('BEE37' /* Conferência */),
        I18n.t('BEE4358' /* A quantidade conferida é superior à quantidade pendente para Cross-Docking */),
        'top-right',
      );
      await this.props.confirmCrossdocking(false);
      return;
    }
    await this.props.confirmCrossdocking(data);

    addNotification(
      'success',
      I18n.t('BEE37' /* Conferência */),
      I18n.t('BEE4429', { 0: data.customerOrderCode || '' } /* O pedido %{0} foi selecionado para conferência. */),
      'top-right',
    );
  };

  filterCustomerOrders = (customerOrders) => customerOrders.filter((order) => parseFloat(order.quantity) - parseFloat(order.inboundQuantityCheck) > 0);

  render() {
    const {
      title,
    } = this.props;
    const {
      customerOrders,
      tableColumns,
    } = this.state;

    return (
      <div className="table-responsive">
        <Table
          headerTitle={title}
          data={customerOrders}
          columns={tableColumns}
          expander
          filterable
          defaultPageSize={this.props.lines ? this.props.lines : 10}
          defaultSorted={this.defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          panelHeaderProps={{
            noButton: true,
          }}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: async () => {
                  await this.selectCustomerOrder(rowInfo.original);
                },
                style: {
                  cursor: 'pointer',
                },
              };
            }
            return {};
          }}
        />
      </div>
    );
  }
}
